export default __webpack_public_path__ + "static/media/sticky-logo.72866906.png";